import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const oppTeamStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space["2xs"],
});
